import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/origen-de-recurso-de-nomina';

/**
 * GET Origen de recurso de nómina
 * @returns {Promise<object[]>}
 */
export const getOrigenesRecursosNominas = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
    /* eslint-disable-next-line no-unreachable */
  } catch (err) {
    onError(err);
  }
  return [];
};
